enum StripeSubscriptionKind {
  Free = "team",
  Pro = "pro",
  Business = "business",
  BusinessPlus = "business_plus",
}

export default StripeSubscriptionKind;
